import { useState, useEffect } from "react";
import { Typography, Stack } from "@mui/material";
import PropTypes from 'prop-types';
import SelectPoste from "./selectPoste";

function Lundi({ data_lundi, onLundiChange, triggerResetLundi }) {

  const [lundi, setLundi] = useState({
    c_09_12: '',
    c_12_15: '',
  });

  const [l_09_12, setL_09_12] = useState([]);
  const [l_12_15, setL_12_15] = useState([]);


  //---------------------------------------------------------------------------
  // création des listes de postes pour les créneaux du lundi
  //---------------------------------------------------------------------------
  useEffect(() => {
    /*
    setL_09_12(data_lundi.filter((ligne) => ligne[0] && ligne[0].trim().length > 0)
      .map((ligne) => `${ligne[0]} (${ligne[2]}/${ligne[3]})`));
    setL_12_15(data_lundi.filter((ligne) => ligne[4] && ligne[4].trim().length > 0)
      .map((ligne) => `${ligne[4]} (${ligne[6]}/${ligne[7]})`));
    */
    setL_09_12(data_lundi.map((ligne) => ligne[0]).filter(str => str.trim().length > 0));
    setL_12_15(data_lundi.map((ligne) => ligne[4]).filter(str => str.trim().length > 0));

  }, [data_lundi]);

  //---------------------------------------------------------------------------
  // mise à jour des données dans le composant parent
  //---------------------------------------------------------------------------
  useEffect(() => {
    onLundiChange(lundi);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lundi]);

  //---------------------------------------------------------------------------
  // reset des info du lundi
  //---------------------------------------------------------------------------
  useEffect(() => {
    if (triggerResetLundi) {
      setLundi({
        c_09_12: '',
        c_12_15: '',
      });
    }
  }, [triggerResetLundi]);

  //---------------------------------------------------------------------------
  // HMI
  //---------------------------------------------------------------------------
  return (
    <Stack spacing={1} bgcolor={'#ead1dc'} alignItems={'center'} sx={{ width: '100%' }}>
      <Typography variant="h6" align="center">
        Lundi
      </Typography>

      <SelectPoste
        label="09h00-12h00"
        value={lundi.c_09_12}
        onChange={(event) => { setLundi({ ...lundi, c_09_12: event.target.value }); }}
        items={l_09_12}
      />

      <SelectPoste
        label="12h00-15h00"
        value={lundi.c_12_15}
        onChange={(event) => { setLundi({ ...lundi, c_12_15: event.target.value }); }}
        items={l_12_15}
      />
    </Stack>

  );
};

Lundi.propTypes = {
  data_lundi: PropTypes.any.isRequired,
  onLundiChange: PropTypes.any.isRequired,
  triggerResetLundi: PropTypes.any.isRequired
};

export default Lundi;